import { Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ObservationService } from 'src/app/services/observation.service';
import { ContactTypeEnum } from 'src/app/shared/enums/contact-type.enum';
import { ObsForm } from 'src/app/shared/models/obs-form.model';
import { ObservationDetailsComponent } from '../observation/observation-details/observation-details.component';
import { internCertDetails } from 'src/app/shared/models/internCertDetails';
import { InternService } from 'src/app/services/intern.service';
import { GlobalService } from 'src/app/services/global.service';
import { FieldSupervisor } from 'src/app/shared/models/fsupervisor.model';
import { observations } from 'src/app/shared/models/observations';
import { StateEnum } from 'src/app/shared/enums/state.enum';
import { campus } from 'src/app/shared/models/campus';
import { FsContact } from 'src/app/shared/models/fs-contact.model';
import { FSContactsService } from 'src/app/services/fs-contacts.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ObsQuestionResponse } from 'src/app/shared/models/obs-question-response.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ObservationFormErrorSheetComponent } from '../observation/observation-form-error-sheet/observation-form-error-sheet.component';
import { ObsDetailsComponent } from './obs-details/obs-details.component';
import { ObsDomainsComponent } from './obs-domains/obs-domains.component';
import { ObsSummaryComponent } from './obs-summary/obs-summary.component';
import { ObsConferenceComponent } from './obs-conference/obs-conference.component';
import { Result } from 'src/app/shared/models/result.model';
import { CachedFsContact } from 'src/app/shared/models/cached-fs-contact.model';
import { SpinnerOverlayComponent } from 'src/app/shared/spinner-overlay/spinner-overlay.component';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObsStatusEnum } from 'src/app/shared/enums/obs-Status.enum';
import { CompanyEnum } from 'src/app/shared/enums/company-enum.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
  standalone: false,
  selector: 'app-obs-assessment',
  templateUrl: './obs-assessment.component.html',
  styleUrls: ['./obs-assessment.component.scss']
})
export class ObsAssessmentComponent implements AfterViewInit, OnDestroy {

  isLoading: boolean;
  internId: string;
  stateId: string;
  programId: string;
  assessmentId: any;
  completed: boolean;
  hasObservationConfiguration: boolean = false;
  showConfigurableObservation: boolean = false;
  saveButtonClicked: boolean = false;
  finishButtonClicked: boolean = false;
  disableSaveButton: boolean = false;
  disableShareDraftButton: boolean = true;
  cancelBackButtonText: string = 'CANCEL';
  legendText: string = 'Observation';
  fsContact: FsContact;
  obsForm: ObsForm = new ObsForm();
  lstcert: internCertDetails;
  isTexasObs: boolean;
  lstObservations: observations[] = [];
  fieldSupervisor: FieldSupervisor;
  nextObservation: observations;
  campus: campus = new campus();
  obsLoading: boolean;
  obsAssessmentForm: FormGroup;
  responseValidationFeedback: string[] = [];
  cachedFsContact: CachedFsContact;
  private formValueChangesSubscription: Subscription;
  profileId: string;
  isShareDraftOption: boolean = false;
  isTeach: boolean;
  private obsFormLoaded: boolean = false;
  private pendingContactLoad: boolean = false;

  @ViewChild(ObservationDetailsComponent) observationDetails: ObservationDetailsComponent;
  @ViewChild(ObsDetailsComponent) obsDetails: ObsDetailsComponent;
  @ViewChild(ObsDomainsComponent) obsDomains: ObsDomainsComponent;
  @ViewChild(ObsSummaryComponent) obsSummary: ObsSummaryComponent;
  @ViewChild(ObsConferenceComponent) obsConference: ObsConferenceComponent;

  @ViewChild('observationDetailsContainer', { read: ViewContainerRef }) observationDetailsContainer!: ViewContainerRef;
  @ViewChild('obsDetailsContainer', { read: ViewContainerRef }) obsDetailsContainer!: ViewContainerRef;
  @ViewChild('obsDomainsContainer', { read: ViewContainerRef }) obsDomainsContainer!: ViewContainerRef;
  @ViewChild('obsSummaryContainer', { read: ViewContainerRef }) obsSummaryContainer!: ViewContainerRef;
  @ViewChild('obsConferenceContainer', { read: ViewContainerRef }) obsConferenceContainer!: ViewContainerRef;
  @ViewChild('spinnerContainer', { read: ViewContainerRef }) spinnerContainer!: ViewContainerRef;

  private observationDetailsRef?: ComponentRef<ObservationDetailsComponent>;
  private obsDetailsRef?: ComponentRef<ObsDetailsComponent>;
  private obsDomainsRef?: ComponentRef<ObsDomainsComponent>;
  private obsSummaryRef?: ComponentRef<ObsSummaryComponent>;
  private obsConferenceRef?: ComponentRef<ObsConferenceComponent>;
  private spinnerRef?: ComponentRef<SpinnerOverlayComponent>;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private observationService: ObservationService,
    private fsContactsService: FSContactsService,
    private internService: InternService,
    private globalService: GlobalService,
    private bottomSheet: MatBottomSheet,
    private snackBar: MatSnackBar,
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (!this.authService.authenticated) {
      this.router.navigate(['auth']);
    }

    if (this.authService.authenticated) {
      if (this.globalService.supervisor != undefined) {
        this.fieldSupervisor = this.globalService.supervisor;
      }
    }

    this.internId = this.activatedRoute.snapshot.paramMap.get('id');
    this.assessmentId = this.activatedRoute.snapshot.paramMap.get('assessId');
    this.completed = this.activatedRoute.snapshot.paramMap.get('completed') === 'true' ? true : false;
    this.stateId = this.activatedRoute.snapshot.paramMap.get('stateId');
    let hasStaticObservation = this.activatedRoute.snapshot.paramMap.get('staticObs') === 'true' ? true : false;
    this.cancelBackButtonText = this.completed ? 'BACK' : 'CANCEL';
    this.profileId = this.activatedRoute.snapshot.paramMap.get('profileId');
    this.programId = this.activatedRoute.snapshot.paramMap.get('programId');

    // staticObs is only true when opening an existing v1 observation for viewing/editing.
    // New observations never set this flag, so hasObservationConfiguration is always true for them.
    this.hasObservationConfiguration = !hasStaticObservation;

    // v1 observations are always read-only — force completed regardless of the route param.
    if (hasStaticObservation) {
      this.completed = true;
    }

    if (this.assessmentId && this.hasObservationConfiguration) {
      // Existing v2 observation: load form config eagerly alongside intern details.
      this.getObsForm();
    }
    // Intern details are always loaded immediately so the contact type dropdown is usable.
    // For new observations, getObsForm() is deferred until the user selects the Observation
    // contact type, so a form load failure does not block all other contact type selections.
    this.getInternsDetails();
    this.obsAssessmentForm = this.fb.group({});
    this.setupFormChangeDetection();
    this.isLoading = false;
  }

  ngAfterViewInit(): void {
    if (!this.isLoading) {
      setTimeout(() => {
        this.cdr.detectChanges();
        this.createChildComponents();
      }, 0);
    }
  }

  private createChildComponents(): void {
    // Destroy only the configurable observation sub-components to prevent duplicates.
    // ObservationDetailsComponent is kept alive so the Contact Type selection is preserved.
    this.destroyConfigurableComponents();

    // Create ObservationDetailsComponent only once
    if (this.observationDetailsContainer && !this.observationDetailsRef) {
      this.observationDetailsRef = this.observationDetailsContainer.createComponent(ObservationDetailsComponent);
      this.observationDetailsRef.instance.internId = this.internId;
      this.observationDetailsRef.instance.assessmentId = this.assessmentId;
      this.observationDetailsRef.instance.completed = this.completed ? 'true' : 'false';
      this.observationDetailsRef.instance.hideStaticObservation = this.hasObservationConfiguration;
      this.observationDetailsRef.instance.contactTypeChange.subscribe((event: any) => {
        this.onContactTypeChange(event);
      });
      this.observationDetailsRef.instance.contactDateChange.subscribe((event: any) => {
        this.onContactDateChange(event);
      });
      this.observationDetails = this.observationDetailsRef.instance;
    } else if (this.observationDetailsRef) {
      // Keep the existing instance but refresh the hideStaticObservation binding in case it changed
      this.observationDetailsRef.instance.hideStaticObservation = this.hasObservationConfiguration;
    }

    // Create configurable observation components if needed.
    const activeContactTypeId = this.fsContact?.contactTypeId ?? this.observationDetails?.obsAssessment?.ContactTypeId;
    if (this.showConfigurableObservation && this.obsFormLoaded && !this.obsLoading && this.fsContact && this.fsContact.fsObservation
        && activeContactTypeId == ContactTypeEnum.Observation) {
      if (this.obsDetailsContainer) {
        this.obsDetailsRef = this.obsDetailsContainer.createComponent(ObsDetailsComponent);
        this.obsDetailsRef.instance.obsAssessmentForm = this.obsAssessmentForm;
        this.obsDetailsRef.instance.fsObservation = this.fsContact.fsObservation;
        this.obsDetailsRef.instance.isTexasObs = this.isTexasObs;
        this.obsDetailsRef.instance.campus = this.campus;
        this.obsDetailsRef.instance.completed = this.completed;
        this.obsDetailsRef.instance.isTeach = this.isTeach;
        this.obsDetailsRef.instance.showLiteracyFocused = this.fsContact.showLiteracyFocused;
        this.obsDetailsRef.instance.requiredDetailsInvalid.subscribe((event: any) => {
          this.onRequiredDetailsInvalid(event);
        });
        this.obsDetails = this.obsDetailsRef.instance;
      }
      
      if (this.obsDomainsContainer && this.obsForm.obsDomains && this.obsForm.obsRatings) {
        this.obsDomainsRef = this.obsDomainsContainer.createComponent(ObsDomainsComponent);
        this.obsDomainsRef.instance.obsAssessmentForm = this.obsAssessmentForm;
        this.obsDomainsRef.instance.obsForm = this.obsForm;
        this.obsDomainsRef.instance.fsObservation = this.fsContact.fsObservation;
        this.obsDomainsRef.instance.completed = this.completed;
        this.obsDomainsRef.instance.isTeach = this.isTeach;
        this.obsDomains = this.obsDomainsRef.instance;
      }
      
      if (this.obsSummaryContainer) {
        this.obsSummaryRef = this.obsSummaryContainer.createComponent(ObsSummaryComponent);
        this.obsSummaryRef.instance.assessmentId = this.assessmentId;
        this.obsSummaryRef.instance.obsAssessmentForm = this.obsAssessmentForm;
        this.obsSummaryRef.instance.fsObservation = this.fsContact.fsObservation;
        this.obsSummaryRef.instance.completed = this.completed;
        this.obsSummaryRef.instance.profileId = this.profileId;
        this.obsSummary = this.obsSummaryRef.instance;
      }
      
      if (this.obsConferenceContainer) {
        this.obsConferenceRef = this.obsConferenceContainer.createComponent(ObsConferenceComponent);
        this.obsConferenceRef.instance.obsAssessmentForm = this.obsAssessmentForm;
        this.obsConferenceRef.instance.fsObservation = this.fsContact.fsObservation;
        this.obsConferenceRef.instance.completed = this.completed;
        this.obsConferenceRef.instance.obsCoachName = this.fsContact.fsFullName;
        this.obsConferenceRef.setInput('contactDate', this.fsContact.contactDate);
        this.obsConferenceRef.instance.preConferenceFieldsValid.subscribe((event: any) => {
          this.onPreConferenceValidityChanged(event);
        });
        this.obsConference = this.obsConferenceRef.instance;
      }
    }
  }

  setupFormChangeDetection() {
    this.formValueChangesSubscription = this.obsAssessmentForm.valueChanges.subscribe(() => {
      if (this.obsAssessmentForm.dirty) {
        this.saveFsContactToLocalCache();
      }
    });
  }

  onContactDateChange(updatedContactDate: string) {
    if (this.fsContact) {
      this.fsContact.contactDate = updatedContactDate;
    }
    this.obsConferenceRef?.setInput('contactDate', updatedContactDate);
  }

  getObsForm(showPageSpinner: boolean = true) {
    // Only set isLoading when called during initial page load. When called after the user selects
    // a contact type, the page is already rendered and setting isLoading would destroy the template.
    if (showPageSpinner) {
      this.isLoading = true;
    }
    this.observationService.GetObsForm(this.programId).subscribe({
      next: (result) => {
        if (result.success && result.returnObj) {
          this.obsForm = result.returnObj as ObsForm;
          if (this.obsForm) {
            // Only promote to true — never overwrite a false set from staticObs (v1 read-only mode).
            if (this.hasObservationConfiguration) {
              this.hasObservationConfiguration = true;
            }
            this.obsFormLoaded = true;
          }
        }
        else {
          console.log(result.userMsg);
          this.snackBar.open('The observation form failed to load. Please select a different contact type and then select observation again.', 'Ok', { panelClass: 'custom-snackbar' });
          this.pendingContactLoad = false;
        }
        this.isLoading = false;
        // Create components after template is rendered
        setTimeout(() => {
          this.cdr.detectChanges();
          this.createChildComponents();
        }, 0);
        // If the user already selected Observation contact type while the form was loading, proceed now.
        if (this.pendingContactLoad) {
          this.pendingContactLoad = false;
          this.loadEarliestScheduledContact();
        }
      },
      error: (errorObj) => {
        this.isLoading = false;
        this.pendingContactLoad = false;
        if (errorObj.error && errorObj.error.userMsg) {
          console.log(errorObj.error.userMsg);
        }
        this.snackBar.open('The observation form failed to load. Please select a different contact type and then select observation again.', 'Ok', { panelClass: 'custom-snackbar' });

        setTimeout(() => {
          this.cdr.detectChanges();
          this.createChildComponents();
        }, 0);
      }
    });
  }

  onContactTypeChange(contactTypeId: Number) {
    // Check for TX 2024 informal observation restrictions
    if (contactTypeId.toString() === ContactTypeEnum.InformalObservation.toString()) {
      const validationError = this.validateInformalObservationSelection();
      if (validationError) {
        this.showInformalObservationError(validationError);
        this.showConfigurableObservation = false;
        return;
      }
    }

    if (!this.hasObservationConfiguration || contactTypeId.toString() !== ContactTypeEnum.Observation.toString()) {
      this.showConfigurableObservation = false;
      return;
    }

    // If contact is already loaded, just show the configurable observation
    if (this.fsContact) {
      this.showConfigurableObservation = true;
      // Recreate components to show configurable observation sections
      setTimeout(() => {
        this.createChildComponents();
        this.cdr.detectChanges();
      }, 0);
      return;
    }

    // If the observation form config hasn't been loaded yet, trigger it now and defer contact loading until it completes.
    if (!this.obsFormLoaded) {
      this.pendingContactLoad = true;
      this.getObsForm(false); // page is already rendered — do not set isLoading
      return;
    }

    this.loadEarliestScheduledContact();
  }

  private loadEarliestScheduledContact(): void {
    // Find earliest incomplete scheduled observations
    const earliestFsContact = this.lstcert.FsContacts?.find(contact => contact.ObsTypeId === ContactTypeEnum.Observation && contact.ObsStatusId === ObsStatusEnum.Scheduled);

    const earliestObservation = this.lstcert.Observations?.find(contact => contact.ObsMethodId === ContactTypeEnum.Observation && contact.ObsStatusId === ObsStatusEnum.Scheduled);

    // Determine which assessment to load based on scheduled dates
    const assessmentIdToLoad = this.getEarliestAssessmentId(earliestFsContact, earliestObservation);

    if (assessmentIdToLoad) {
      this.getFsContact(assessmentIdToLoad);
    }
  }

  private getEarliestAssessmentId(fsContact: any, observation: any): number | null {
    if (!fsContact && !observation) {
      return null;
    }

    if (!fsContact) {
      return observation.AssessmentId;
    }

    if (!observation) {
      return fsContact.AssessmentId;
    }

    // Convert scheduled dates to Date objects for proper comparison
    const fsContactDate = new Date(fsContact.ScheduledDate);
    const observationDate = new Date(observation.ScheduledDate);

    return fsContactDate <= observationDate ? fsContact.AssessmentId : observation.AssessmentId;
  }

  getInternsDetails() {
    this.lstcert = new internCertDetails;
    this.internService.getInternDetailsById(this.internId, this.fieldSupervisor.FieldSupervisorId).subscribe(data => {
      this.lstcert = data;
      this.isTexasObs = this.lstcert?.Intern?.stateId == StateEnum.TX;
      this.isTeach = this.lstcert?.Intern?.companyId == CompanyEnum.Teach;
      this.campus = this.lstcert?.Campus;
      this.LoadObservations();

      if (this.assessmentId) {
        this.getFsContact(this.assessmentId);
      }
    });

  }

  LoadObservations() {
    this.lstcert.Certificates.forEach(element => {
      element.Observations.forEach(obs => {
        if (!(obs.IsCompleted || obs.IsSaved) || this.assessmentId) {
          this.lstObservations.push(obs);
        }
      });
    });

    this.nextObservation = this.lstObservations[0];
  }

  getFsContact(assessmentId: number) {
    this.obsLoading = true;
    this.fsContactsService.GetFSContact(assessmentId).subscribe({
      next: result => {
        if (result.success && result.returnObj) {
          this.fsContact = result.returnObj as FsContact;

          if (this.observationDetails) {
            if (this.fsContact.contactDate) {
              this.observationDetails.obsAssessment.Date = this.fsContact.contactDate;
            } else {
              this.fsContact.contactDate = this.observationDetails.obsAssessment.Date;
            }

            if (this.fsContact.contactTypeId) {
              this.observationDetails.obsAssessment.ContactTypeId = this.fsContact.contactTypeId;
            }
          }

          this.loadCachedFsContact();

          this.showConfigurableObservation = this.hasObservationConfiguration;
        }
        this.obsLoading = false;
        // Recreate components to include configurable observation sections
        setTimeout(() => {
          this.createChildComponents();
          this.cdr.detectChanges();
        }, 0);
      },
      error: () => {
        this.obsLoading = false;
        if (this.observationDetails) {
          this.observationDetails.obsAssessment.ContactTypeId = 0;
        }
        this.snackBar.open('An error occurred while loading observation', 'Ok', { panelClass: 'custom-snackbar' });
      }
    });
  }

  finishAssessment() {
    this.finishButtonClicked = true;
    this.showSpinner();
    if (this.formalObsValidation(true)) {
      this.mapFormToFsContact();
      this.fsContactsService.FinishFsContact(this.fsContact).subscribe({
        next: (result) => {
          if (result.success) {
            if (Array.isArray(result.returnObj) && result.returnObj.length > 0) {
              const data = result.returnObj as string[];
              const emailRecipients = [
                data.slice(0, -1)
                  .join(', '),
                ...data.slice(-1)]
                .filter(x => x)
                .join(' and ');
              this.openSnackBar(`Completed Observation is queued to be emailed to ${emailRecipients}`, 'Ok', 10000)
              this.clearCachedFsContact();
            }
            this.router.navigate(['/intern-details', this.internId]);
          }
          else {
            this.HandleFinishAssessmentError(result);
          }
          this.finishButtonClicked = false;
          this.hideSpinner();
        },
        error: (errorObj) => {
          if (errorObj.error && errorObj.error.userMsg) {
            this.openSnackBar(errorObj.error.userMsg, 'Ok');
          }
          else {
            this.openSnackBar('An error occurred while submitting observation form', 'Ok');
          }
          this.finishButtonClicked = false;
          this.hideSpinner();
        }
      });
    }
    else {
      this.finishButtonClicked = false;
      this.hideSpinner();
    }
  }

  HandleFinishAssessmentError(result: Result) {
    switch (result.statusCode) {
      case 'VALIDATION_FAILED': {
        if (Array.isArray(result.returnObj)) {
          let errorList: string[] = result.returnObj as string[];
          this.responseValidationFeedback = [];
          this.responseValidationFeedback.push(...errorList);
          if (this.responseValidationFeedback.length > 0) {
            this.showErrorList(true);
          }
        }
        break;
      }

      case 'PDF_GENERATION_FAILED':
      case 'EMAIL_SEND_FAILED': {
        this.openSnackBar(result.userMsg, 'Ok', 10000);
        this.router.navigate(['/intern-details', this.internId]);
        break;
      }

      case 'ASSESSMENT_SUBMISSION_FAILED':
      default: {
        this.openSnackBar('An error occurred while submitting observation form', 'Ok');
      }
    }
  }

  shareDraftAssessment() {
    this.isShareDraftOption = true;
    this.fsContact.isShareDraftOption = true;
    this.saveAssessment();
  }

  saveAssessment() {
    this.saveButtonClicked = true;
    this.showSpinner();
    if (this.formalObsValidation()) {
      this.mapFormToFsContact();
      this.fsContactsService.UpdateFsContact(this.fsContact).subscribe({
        next: (result) => {
          if (result.success) {

            const successMessage = this.isShareDraftOption
              ? "Observation saved and observation draft emailed to Intern"
              : "Observation form saved successfully";

            this.openSnackBar(successMessage, "Ok");
            this.clearCachedFsContact();
            this.router.navigate(['/intern-details', this.internId]);
          }
          else {
            if (Array.isArray(result.returnObj)) {
              let errorList: string[] = result.returnObj as string[];
              this.responseValidationFeedback = [];
              this.responseValidationFeedback.push(...errorList);
              if (this.responseValidationFeedback.length > 0) {
                this.showErrorList();
              }
            }
            else {
              const errorMessage = result.userMsg?.trim()
                ? result.userMsg
                : this.isShareDraftOption
                  ? "An error occurred while saving the observation and sharing the draft."
                  : "An error occurred while saving observation form";

              this.openSnackBar(errorMessage, "Ok");
            }
          }
          this.saveButtonClicked = false;
          this.isShareDraftOption = false;
          this.fsContact.isShareDraftOption = false;
          this.hideSpinner();
        },
        error: (errorObj) => {
          if (errorObj.error && errorObj.error.userMsg) {
            this.openSnackBar(errorObj.error.userMsg, 'Ok');
          }
          else {
            const errorMessage = this.isShareDraftOption
              ? "An error occurred while saving the observation and sharing the draft"
              : "An error occurred while saving observation form";

            this.openSnackBar(errorMessage, "Ok");
          }
          this.saveButtonClicked = false;
          this.isShareDraftOption = false;
          this.fsContact.isShareDraftOption = false;
          this.hideSpinner();
        }
      });
    }
    else {
      this.saveButtonClicked = false;
      this.isShareDraftOption = false;
      this.fsContact.isShareDraftOption = false;
      this.hideSpinner();
    }
  }

  formalObsValidation(finishing: boolean = false): boolean {
    this.responseValidationFeedback = [];

    this.ValidateContactDate();

    let obsDetailsErrors = this.obsDetails.validateForm();
    let obsDomainsErrors = this.obsDomains.validateForm(finishing || this.isShareDraftOption);
    let obsSummaryErrors = this.obsSummary.validateForm(finishing || this.isShareDraftOption);
    let obsConferenceErrors = this.isShareDraftOption ? this.obsConference.validateFormForShareDraft() : this.obsConference.validateForm(finishing);

    this.responseValidationFeedback = [
      ...this.responseValidationFeedback,
      ...obsDetailsErrors,
      ...obsDomainsErrors,
      ...obsSummaryErrors,
      ...obsConferenceErrors
    ];

    if (this.responseValidationFeedback.length > 0) {
      this.showErrorList(finishing);
      return false;
    }
    return true;
  }

  private ValidateContactDate() {
    let contactDateError = this.observationDetails.ValidateContactDate();
    if (this.observationDetails.ValidateContactDate()) {
      this.responseValidationFeedback.push(contactDateError);
    }
  }

  private async showErrorList(finishing: boolean = false) {
    let method = finishing ? 'finish' : 'save';

    method = this.shareDraftAssessment ? 'share draft' : method;

    const scrolled = await this.obsDomains.scrollToFirstFieldError();
    if (!scrolled) {
      await this.obsSummary.scrollToFirstFieldError();
    }

    const sheet = this.bottomSheet.open(ObservationFormErrorSheetComponent, {
      restoreFocus: false,
      data: {
        title: `Please provide the information listed below to ${method} your observation.`,
        messages: this.responseValidationFeedback
      }
    });
    sheet.afterDismissed().subscribe(async () => {
      const scrolled = await this.obsDomains.scrollToFirstFieldError();
      if (!scrolled) {
        await this.obsSummary.scrollToFirstFieldError();
      }
    });
  }

  mapFormToFsContact() {
    this.fsContact.contactDate = this.observationDetails.obsAssessment.Date;
    this.fsContact.contactTypeId = ContactTypeEnum.Observation;
    this.fsContact.campusId = this.fsContact.campusId ?? this.campus?.CampusId ?? null;
    this.fsContact.fsFullName = this.fieldSupervisor.FirstName + ' ' + this.fieldSupervisor.LastName;
    this.fsContact.fsId = this.fieldSupervisor.FieldSupervisorId ?? this.fsContact.fsId;
    this.fsContact.fsEmail = this.fieldSupervisor.PrimaryEmail;
    this.fsContact.isFullTimeEmployee = this.fieldSupervisor.isFullTimeEmployee;
    this.fsContact.stateId = this.stateId;
    this.fsContact.fsObservation.obsForm = this.obsForm;

    const obsDetailsValues = this.obsAssessmentForm.getRawValue().obsDetails;
    const obsSummaryValues = this.obsAssessmentForm.get('obsSummary')?.value;
    const obsConferenceValues = this.obsAssessmentForm.get('obsConference')?.value;
    const obsDomainsValues = this.obsAssessmentForm.get('obsDomains')?.value;

    this.fsContact.fsObservation = {
      ...this.fsContact.fsObservation,
      ...obsDetailsValues,
      ...obsSummaryValues,
      ...obsConferenceValues
    };

    if (obsDomainsValues) {
      this.mapObsDomainsValuesToResponses(obsDomainsValues);
    }
  }

  mapObsDomainsValuesToResponses(obsDomainsValues: any) {
    this.fsContact.fsObservation.obsQuestionResponses = [];

    Object.entries(obsDomainsValues)
      .filter(([, response]) => response !== null && response !== '')
      .forEach(([questionId, response]) => {
      const newResponse = new ObsQuestionResponse();
      newResponse.id = +questionId;
      newResponse.response = response;

      for (const domain of this.obsForm.obsDomains) {
        for (const category of domain.obsCategories) {
          if (category.obsQuestions.some(question => question.id === newResponse.id)) {
            newResponse.obsCategoryId = category.id;
            newResponse.obsCategoryDescription = category.description;
            let obsQuestion = category.obsQuestions.find(q => q.id === newResponse.id);
            newResponse.responseTypeId = obsQuestion.responseTypeId;
            newResponse.obsQuestionDescription = obsQuestion.description;
          }
        }
      }

      this.fsContact.fsObservation.obsQuestionResponses.push(newResponse);
    });
  }

  cancel() {
    this.formValueChangesSubscription.unsubscribe();
    var backupRestored = this.localStorageService.restoreBackupCachedItem(`fsContact-${this.fsContact.assessmentId.toString()}`);

    var message = backupRestored ? 'Previous locally saved contact form data restored' : 'Contact form data not saved locally';
    this.openSnackBar(message, 'Ok');

    this.router.navigate(['/intern-details', this.internId]);
  }

  openSnackBar(data: string, status: string, duration: number = 5000) {
    this.snackBar.open(data, status, {
      duration: duration,
      panelClass: 'custom-snackbar'
    });
  }

  onRequiredDetailsInvalid(requiredDetailsInvalid: boolean) {
    this.disableSaveButton = requiredDetailsInvalid;
  }

  saveFsContactToLocalCache(): void {
    this.mapFormToFsContact();

    if (!this.cachedFsContact) {
      this.cachedFsContact = new CachedFsContact();
    }

    this.cachedFsContact.assessmentId = this.fsContact.assessmentId;
    this.cachedFsContact.fsContact = this.fsContact;
    this.cachedFsContact.profileId = this.lstcert?.Intern?.profileId;
    this.cachedFsContact.saveDate = new Date();

    this.localStorageService.saveItemToCache(`fsContact-${this.fsContact.assessmentId.toString()}`, this.cachedFsContact);
  }

  loadCachedFsContact(): void {
    try {
      const cachedFsContact = this.localStorageService.loadItemFromCacheWithBackup<CachedFsContact>(`fsContact-${this.fsContact.assessmentId.toString()}`);

      if (cachedFsContact &&
        cachedFsContact.profileId === this.lstcert?.Intern?.profileId &&
        cachedFsContact.assessmentId === this.fsContact.assessmentId) {
        this.fsContact = cachedFsContact.fsContact;
      }
    } catch (error) {
      console.error('Error loading observation assessment from local storage:', error);
      this.openSnackBar('An error occurred while loading the observation assessment. Please try again.', 'Ok');
    }
  }

  clearCachedFsContact(): void {
    this.formValueChangesSubscription.unsubscribe();
    this.localStorageService.removeAllCachedItemsByKey(`fsContact-${this.fsContact.assessmentId.toString()}`);
  }

  onPreConferenceValidityChanged(isPreconferenceValid: boolean): void {
    this.disableShareDraftButton = !isPreconferenceValid;
  }

  private isTx2024RuleSet(): boolean {
    const ruleSet = this.lstcert?.Intern.RuleSet;
    if (!ruleSet) {
      return false;
    }
    const year = ruleSet.trim().substring(ruleSet.length - 4);
    const ruleSetYear = parseInt(year);
    return ruleSetYear >= 2024;
  }

  private validateInformalObservationSelection(): string | null {

    if (!this.isTx2024RuleSet() || this.stateId !== StateEnum.TX.toString()) {
      return null;
    }

    const firstFormalObs = this.lstcert.FsContacts?.find(contact => contact.ObsTypeId === ContactTypeEnum.Observation && contact.ObsType.toLocaleLowerCase().startsWith('first'));

    if (!firstFormalObs) {
      return null;
    }

    // Check if first formal observation is submitted or beyond
    const isSubmittedOrAccepted = firstFormalObs.ObsStatusId > ObsStatusEnum.Saved;

    if (!isSubmittedOrAccepted) {
      return 'First formal observation needs to be completed before first informal observation';
    }

    return null;
  }

  private showInformalObservationError(errorMessage: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Validation Error',
        message: errorMessage,
        hideCancelButton: true,
        confirmButtonText: 'OK'
      }
    });
  }

  private showSpinner(): void {
    if (this.spinnerContainer && !this.spinnerRef) {
      this.spinnerRef = this.spinnerContainer.createComponent(SpinnerOverlayComponent);
      this.spinnerRef.instance.overlay = true;
      this.spinnerRef.instance.diameter = 100;
      this.spinnerRef.instance.mode = 'indeterminate';
      this.spinnerRef.instance.strokeWidth = 10;
    }
  }

  private hideSpinner(): void {
    this.spinnerRef?.destroy();
    this.spinnerRef = undefined;
  }

  private destroyConfigurableComponents(): void {
    this.obsDetailsRef?.destroy();
    this.obsDetailsRef = undefined;

    this.obsDomainsRef?.destroy();
    this.obsDomainsRef = undefined;

    this.obsSummaryRef?.destroy();
    this.obsSummaryRef = undefined;

    this.obsConferenceRef?.destroy();
    this.obsConferenceRef = undefined;
  }

  private destroyChildComponents(): void {
    // Destroy all existing component references
    this.observationDetailsRef?.destroy();
    this.observationDetailsRef = undefined;

    this.destroyConfigurableComponents();

    this.spinnerRef?.destroy();
    this.spinnerRef = undefined;
  }

  get showConfigurableObservationForm(): boolean {
    const contactTypeId = this.fsContact?.contactTypeId ?? this.observationDetails?.obsAssessment?.ContactTypeId;
    return this.showConfigurableObservation && contactTypeId == ContactTypeEnum.Observation;
  }

  ngOnDestroy(): void {
    // Clean up dynamically created components
    this.destroyChildComponents();
    
    // Clean up form subscription
    this.formValueChangesSubscription?.unsubscribe();
  }
}
